// This file is auto-generated. Edit data.graphql to change it.
import { DataProvider , useSetFlowToBasedOnData } from 'Simple/Data'
import { useSubscription } from 'Data/Api'
import query from './data.graphql.js'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function InputsData(props) {
  let [{ data: rdata, error }, reExecuteQuery] = useSubscription({ query })
  let data = rdata?.onboarding_inputs

      useSetFlowToBasedOnData({
        data,
        fetching: typeof data === 'undefined',
        error,
        pause: false,
        viewPath: props.viewPath,
      })
      

  return (
    <DataProvider
      context="inputs"
      value={data}
      viewPath={props.viewPath}
    >
      <View {...props} />
    </DataProvider>
  )
}